module.exports = __webpack_public_path__ + "/c6dfb70e4f54aea261afd655b951d751.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/images/customers/logos/instacart.svg
 ** module id = 1182
 ** module chunks = 0
 **/